import { Button } from 'antd';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router';

export function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="grid min-h-screen place-items-center bg-page px-6">
      <div className="text-center">
        <p className="font-mono text-sm font-medium text-primary">404</p>
        <h1 className="mt-3 text-3xl font-semibold tracking-tight text-fg">Page not found</h1>
        <p className="mt-2 text-sm text-muted">The page you were looking for doesn&apos;t exist or has moved.</p>
        <Button className="mt-8" type="primary" size="large" icon={<ArrowLeft className="size-4" />} onClick={() => navigate('/')}>
          Back to dispatch
        </Button>
      </div>
    </div>
  );
}
